import { render, staticRenderFns } from "./AccountChildEditBindDialog.vue?vue&type=template&id=3e691c20&scoped=true"
import script from "./AccountChildEditBindDialog.vue?vue&type=script&lang=ts"
export * from "./AccountChildEditBindDialog.vue?vue&type=script&lang=ts"
import style0 from "./AccountChildEditBindDialog.vue?vue&type=style&index=0&id=3e691c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e691c20",
  null
  
)

export default component.exports